import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { CourseConstants } from '../../constants/course.constants';
import { CoursePersistenceService } from '../../services/course-persistence.service';

@Component({
  selector: 'app-session-attendee-complete-date',
  templateUrl: './session-attendee-complete-date.component.html',
  styleUrls: ['./session-attendee-complete-date.component.scss']
})
export class SessionAttendeeCompleteDateComponent {
  
  readonly completeDateModalText = `Select the date when the Training was completed by the Attendee of this Session. The selected date will be reflected in their Training Plan.`
  maxDateValue: Date = new Date();
  number!: string;
  @Output() completeDate=new EventEmitter<Date>();
   isCompleteDateModalVisible:boolean=false;
  selectedCompleteDate: Date|null = new Date();
  errorMessage: string = CourseConstants.Complete_Date_Required;
  errorMessages: string[] = [];

  constructor(private router: Router, private messageService: MessageService, private coursePersistenceService:CoursePersistenceService) {
    
   } 
   display: boolean = false;
  ngOnInit(): void {
        this.maxDateValue.setDate(new Date().getDate());
        var url = this.router.url;
    var urlParts = this.router.parseUrl(url);
    this.number = urlParts.queryParams['number'];

    this.coursePersistenceService.completeDateModalVisible$.subscribe(data=>{
      this.display=data;
    });
    }

  showDialog() {
      this.display = true;
  }

  cancel(){
    this.display = false;
    this.errorMessages=[];
    const today = new Date();
    this.selectedCompleteDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  }
  
  saveDate(completeDate:any){
    if(completeDate===null || completeDate===undefined){
     
          this.errorMessage = CourseConstants.Complete_Date_Required;
          this.errorMessages.push(this.errorMessage);
      }
      else{
        var selectedCompleteDateValue= new Date(completeDate);
        this.display=false;
        this.coursePersistenceService.updateSessionAttendeeFromTainingCompleteDateModal(selectedCompleteDateValue);
      }
    
  }

}
